import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import ServiceCard from '../components/ServiceCard';
import BookingModal from '../components/BookingModal';
import { trackBookPageView } from '../utils/gtag';
import './Book.css';

function Book({ services }) {
  const [searchParams] = useSearchParams();
  const [selectedService, setSelectedService] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    trackBookPageView();
  }, []);

  useEffect(() => {
    const serviceParam = searchParams.get('service');
    if (serviceParam) {
      const match = services.find(s => s.category === serviceParam);
      if (match) {
        setSelectedService(match);
        setShowModal(true);
      }
    }
  }, [searchParams, services]);

  const handleBookNow = (service) => {
    setSelectedService(service);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedService(null);
  };

  return (
    <main className="book-page">
      <section className="book-hero">
        <div className="book-hero-container">
          <h1>Book Your Mobile Oil Change</h1>
          <p className="book-hero-subtitle">
            Pick your service below — we come to your home, office, or anywhere in Sacramento County.
            Full synthetic oil, licensed & insured, 7-day guarantee.
          </p>
          <div className="book-trust-row">
            <span className="book-trust-item">✓ Licensed & Insured</span>
            <span className="book-trust-item">✓ 7-Day Guarantee</span>
            <span className="book-trust-item">✓ Full Synthetic Oil</span>
            <span className="book-trust-item">✓ Service in 1 Hour</span>
          </div>
        </div>
      </section>

      <section className="book-services">
        <div className="book-services-container">
          <h2>Select a Service</h2>
          <p className="book-services-subtitle">
            Transparent pricing. No hidden fees. Pickup truck prices may vary.
          </p>
          <div className="services-grid">
            {services.map(service => (
              <ServiceCard
                key={service.id}
                service={service}
                onBookNow={() => handleBookNow(service)}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="book-info">
        <div className="book-info-container">
          <div className="book-info-card">
            <h3>How It Works</h3>
            <ol>
              <li>Pick your service and select date/time</li>
              <li>Enter your vehicle and address details</li>
              <li>Our technician arrives and completes the oil change in ~1 hour</li>
              <li>Pay securely — get back to your day</li>
            </ol>
          </div>
          <div className="book-info-card">
            <h3>Service Area</h3>
            <p>
              We cover Sacramento and surrounding areas including Elk Grove, Roseville, Folsom,
              Rancho Cordova, Citrus Heights, Carmichael, Fair Oaks, Orangevale, West Sacramento,
              Davis, and Woodland — up to 25 miles from Sacramento.
            </p>
            <p>
              Need to confirm coverage? <a href="tel:9168188494">Call</a> or{' '}
              <a href="sms:9168188494">text us</a>.
            </p>
          </div>
        </div>
      </section>

      {showModal && selectedService && (
        <BookingModal
          service={selectedService}
          onClose={closeModal}
        />
      )}
    </main>
  );
}

export default Book;
